export enum CustomerPermission {
  /* backup permissions */
  SearchAndRestore = 0,
  FullAccess = 1,
  /* migration permissions */
  ReadOnly = 2,
  ReadAndWrite = 3
}
